import React from "react";
import { Radio, DatePicker, Button, Space, Divider, Modal } from "antd";
import dayjs, { Dayjs } from "dayjs";

interface PostSettingsDrawerProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  scheduleOption: string;
  onScheduleChange: (e: any) => void;
  scheduleTime: Dayjs | null;
  onScheduleTimeChange: (date: Dayjs | null) => void;
}

const PostSettingsDrawer: React.FC<PostSettingsDrawerProps> = ({
  open,
  onClose,
  onConfirm,
  scheduleOption,
  onScheduleChange,
  scheduleTime,
  onScheduleTimeChange,
}) => {
  // Can not select days before today
  const disabledDate = (current: Dayjs) => {
    return current && current < dayjs().startOf("day");
  };
  // Can not select time before current time
  const disabledTime = (now: Dayjs | null) => {
    if (now && now.isSame(dayjs(), "day")) {
      const currentHour = dayjs().hour();
      const currentMinute = dayjs().minute();
      return {
        disabledHours: () => Array.from({ length: currentHour }, (_, i) => i),
        disabledMinutes: (selectedHour: number) => {
          if (selectedHour === currentHour) {
            return Array.from({ length: currentMinute }, (_, i) => i);
          }
          return [];
        },
      };
    }
    return {
      disabledHours: () => [],
      disabledMinutes: () => [],
    };
  };
  return (
    <Modal
      title="Post Settings"
      onCancel={onClose}
      open={open}
      footer={
        <Button type="primary" onClick={onConfirm}>
          Confirm Publish
        </Button>
      }
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <Radio.Group onChange={onScheduleChange} value={scheduleOption}>
          <Radio value="now">Schedule Now</Radio>
          <Radio value="later">Schedule Later</Radio>
        </Radio.Group>
        {scheduleOption === "later" && (
          <DatePicker
            showTime
            style={{ width: "100%", marginTop: "16px" }}
            onChange={onScheduleTimeChange}
            disabledDate={disabledDate}
            disabledTime={disabledTime}
            value={scheduleTime}
          />
        )}
        <Divider />
      </Space>
    </Modal>
  );
};

export default PostSettingsDrawer;
